import {
  Actions,
  Box,
  Button,
  Heading,
  IconChevron,
  Stack,
  Text,
} from 'braid-design-system';

import { TextLink } from 'src/components/Link/Link';
import { TRACKING_CODES } from 'src/constants';
import { useLocale } from 'src/utils/hooks/useContext';

export const ThanksView = ({
  setSubmitted,
}: {
  setSubmitted: (submitted: boolean) => void;
}) => {
  const locale: string = useLocale();

  return (
    <Box>
      <Stack space="medium">
        <Heading level="3">Thanks for contacting us</Heading>
        <Text>
          If you need to speak to us urgently, please call customer service on
          1300 658 700.
        </Text>
        <Text>
          You can also search for answers in our{' '}
          <TextLink
            href={
              locale === 'NZ'
                ? 'https://help.seek.co.nz/employer'
                : 'https://help.seek.com.au/employer'
            }
            skipResolvedUrl={true}
            tracking={TRACKING_CODES.talent_help_center_link_clicked}
          >
            Help centre
          </TextLink>
          .
        </Text>
        <Actions>
          <Button onClick={() => setSubmitted(false)} variant="transparent">
            <IconChevron direction="left" /> Back to form
          </Button>
        </Actions>
      </Stack>
    </Box>
  );
};
